<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم درخواست خرید</h5>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>نام کالا</th>
            <th>تعداد</th>
            <th>قیمت تقریبی (ريال)</th>
            <th>جمع (ريال)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_ProductRequestDetail">
           <td>{{DataList_ProductRequestDetail.indexOf(item)+1}}</td>

            <td>{{item.title}}</td>
            <td>{{item.amount}}</td>
            <td>{{item.price|number}}</td>
            <td>{{(item.price*item.amount)|number}}</td>
          </tr>
          <tr>
            <td colspan="2">جمع کل (ريال)</td>
            <td colspan="4">{{Total_Price_Detail|number}}</td>
          </tr>
        </tbody>
      </table>
   </div>

    <br />
    <hr />
    <br />

    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input value="{{Data_Seleted_Product_Record.dsc}}" disabled type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>

    </div>

    <br />
    <hr />
    <br />

    <h5 class="card-title">مشخصات موردنظر</h5>

    <div class="row">

      <div class="input-group mb-12" *ngFor="let item of Datalist_Dsc" style="margin: 5px;">

        <input type="text" [(ngModel)]="item.title" name="" class="form-control" id="inlineFormInputGroup"
          placeholder="متن خود را وارد نمائید ...">
      </div>


    </div>



  </div>
</div>